import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';

import {
  EURO_ELLIPSE,
  EURO_FIGMA,
  EURO_PRODUCT_WIDTH,
  euroProductLeft,
  HUNTER_ELLIPSE,
  HUNTER_FIGMA,
  HUNTER_PRODUCT_WIDTH,
  IPAD_ELLIPSE,
  IPAD_FIGMA,
  pct,
  PS5_ELLIPSE,
  PS5_FIGMA,
  TOUCHPOINT_TOP_BAND
} from './referralHomeCardConfig';

export const DesktopLayout = styled.div`
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

export const Top = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: calc(${Spacings.SPACING_25B} + ${Spacings.SPACING_1});
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B};
  padding-right: ${Spacings.SPACING_90B};
  overflow: hidden;
  background-image: linear-gradient(
    180deg,
    var(--color-i-blue-9) 40%,
    var(--color-accent-blue) 100%
  );
  ${mediaQuery.uptoMobile} {
    padding-right: ${Spacings.SPACING_40B};
  }
`;

export const Title = styled.p`
  position: relative;
  z-index: 1;
  margin: 0;
  max-width: 100%;
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.H3};
  line-height: ${Spacings.SPACING_8B};
  color: var(--color-text-primary);
`;

export const Highlight = styled.p`
  position: relative;
  z-index: 1;
  margin: ${Spacings.SPACING_1B} 0 0;
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.H3};
  line-height: ${Spacings.SPACING_8B};
  color: var(--color-base-1);
`;

export const Bottom = styled.div`
  position: relative;
  z-index: 1;
  background: var(--color-base-1);
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
  padding-right: ${Spacings.SPACING_90B};
  min-height: ${Spacings.SPACING_25B};
  ${mediaQuery.uptoMobile} {
    padding-right: ${Spacings.SPACING_6B};
  }
`;

export const Subtitle = styled.p`
  margin: 0 0 ${Spacings.SPACING_2B};
  max-width: ${Spacings.SPACING_90B};
  font-size: ${Fonts.H7};
  line-height: ${Spacings.SPACING_18};
  color: var(--color-text-primary);
  opacity: 0.8;
`;

export const Cta = styled.button`
  appearance: none;
  cursor: pointer;
  height: ${Spacings.SPACING_10B};
  padding: 0 ${Spacings.SPACING_6B};
  border-radius: ${Spacings.SPACING_2B};
  border: ${Spacings.SPACING_1} solid var(--color-text-primary);
  background: var(--color-base-1);
  font-family: inherit;
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.H7};
  line-height: ${Spacings.SPACING_5B};
  color: var(--color-text-primary);
`;

export const ProductRail = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  padding-right: ${Spacings.SPACING_4B};
  pointer-events: none;
  z-index: 2;
`;

export const ProductFrame = styled.div<{ $top: string }>`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  margin-top: ${({ $top }) => $top};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_3B};
  }
`;

export const Product = styled.img<{
  $width: string;
  $height: string;
  $objectPosition?: string;
}>`
  position: relative;
  z-index: 1;
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  object-fit: contain;
  object-position: ${({ $objectPosition }) => $objectPosition || 'right top'};
  background: transparent;
  ${mediaQuery.uptoMobile} {
    width: ${Spacings.SPACING_35B};
    height: ${Spacings.SPACING_20B};
  }
`;

export const TopEllipseImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
`;

export const EuroTopEllipseWrap = styled.div`
  position: absolute;
  left: ${pct(EURO_ELLIPSE.left, EURO_FIGMA.width)};
  top: ${pct(EURO_ELLIPSE.top, TOUCHPOINT_TOP_BAND)};
  width: ${pct(EURO_ELLIPSE.size, EURO_FIGMA.width)};
  aspect-ratio: 1;
  pointer-events: none;
  z-index: 0;
`;

export const IpadTopEllipseWrap = styled.div`
  position: absolute;
  left: ${pct(IPAD_ELLIPSE.left, IPAD_FIGMA.width)};
  top: ${pct(IPAD_ELLIPSE.top, TOUCHPOINT_TOP_BAND)};
  width: ${pct(IPAD_ELLIPSE.size, IPAD_FIGMA.width)};
  aspect-ratio: 1;
  pointer-events: none;
  z-index: 0;
`;

export const Ps5TopEllipseWrap = styled.div`
  position: absolute;
  left: ${pct(PS5_ELLIPSE.left, PS5_FIGMA.width)};
  top: ${pct(PS5_ELLIPSE.top, TOUCHPOINT_TOP_BAND)};
  width: ${pct(PS5_ELLIPSE.size, PS5_FIGMA.width)};
  aspect-ratio: 1;
  pointer-events: none;
  z-index: 0;
`;

export const IpadProductSpot = styled.div`
  position: absolute;
  left: ${pct(547, IPAD_FIGMA.width)};
  top: ${pct(9, IPAD_FIGMA.height)};
  width: ${pct(299, IPAD_FIGMA.width)};
  aspect-ratio: 1;
  pointer-events: none;
  z-index: 2;
`;

export const IpadSpotProductClip = styled.div`
  position: absolute;
  left: ${pct(607 - 547, 299)};
  top: ${pct(31 - 9, 299)};
  width: ${pct(196, 299)};
  height: ${pct(172, 299)};
  overflow: hidden;
  pointer-events: none;
  transform: scale(1.15);
  transform-origin: center top;
`;

export const IpadSpotProduct = styled.img`
  position: absolute;
  width: 147.09%;
  height: 167.01%;
  left: -23.8%;
  top: -18.2%;
  max-width: none;
  object-fit: contain;
  object-position: center top;
`;

export const EuroSpotProduct = styled.img`
  position: absolute;
  left: ${euroProductLeft()};
  bottom: 0;
  width: ${pct(EURO_PRODUCT_WIDTH, EURO_FIGMA.width)};
  height: 100%;
  object-fit: contain;
  object-position: center bottom;
  pointer-events: none;
  z-index: 2;
`;

export const HunterSpotRoot = styled.div`
  position: absolute;
  inset: 0;
  padding-right: ${Spacings.SPACING_14};
  box-sizing: border-box;
  pointer-events: none;
  z-index: 1;
`;

export const HunterTopEllipseWrap = styled.div`
  position: absolute;
  right: ${Spacings.SPACING_14};
  top: ${pct(HUNTER_ELLIPSE.top, TOUCHPOINT_TOP_BAND)};
  width: ${pct(HUNTER_ELLIPSE.size, HUNTER_FIGMA.width)};
  aspect-ratio: 1;
  pointer-events: none;
  z-index: 0;
`;

export const HunterSpotProduct = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  width: ${pct(HUNTER_PRODUCT_WIDTH, HUNTER_FIGMA.width)};
  height: 100%;
  object-fit: contain;
  object-position: right bottom;
  pointer-events: none;
  z-index: 2;
`;
